import { Box, Button, Container, Typography } from '@mui/material'
import React, { Component } from 'react'

class HomeComponent extends Component {
    render() {
        return (
            <Container sx={{
                alignItems: 'flex-start',
                height: '70vh',
                width: '100%',
                backgroundColor: 'transparent',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                position: 'initial',
                zIndex: 1,
            }} >
                <Typography className='fadeInLeftToRight' variant='h1' fontSize='4rem' color='white' maxWidth='400px' > Shaping Tomorrow Together </Typography>
                <br/>
                <Typography className=' code-element fadeInRightToLeft ' variant='code' fontSize='1rem' component='h1' fontWeight="fontWeightBold" maxWidth='400px' color='white' >
                    Welcome to Robotics Media, where technology, design, and creativity converge.
                    Explore our world of innovation and expertise as we redefine the digital landscape.
                    Your journey to the future begins here.</Typography>
                <br />
                <Typography className='fadeBottomToTop' variant='h5' fontSize='2rem' color='white' >Tech. Creativity. Your Vision. Our Vision</Typography>
                <Box sx={{ mt: 3, display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                    <Button
                        variant="contained"
                        href="/services"
                        sx={{
                            bgcolor: 'white',
                            color: 'black',
                            fontFamily: 'PT Mono, monospace',
                            fontWeight: 'bold',
                            borderRadius: '10px',
                            '&:hover': { bgcolor: 'white', opacity: 0.9 },
                        }}
                    >
                        VIEW SERVICES
                    </Button>
                    <Button
                        variant="outlined"
                        href="/contact"
                        sx={{
                            color: 'white',
                            borderColor: 'white',
                            fontFamily: 'PT Mono, monospace',
                            fontWeight: 'bold',
                            borderRadius: '10px',
                            '&:hover': { borderColor: 'white', opacity: 0.9 },
                        }}
                    >
                        BOOK A CALL
                    </Button>
                    <Button
                        variant="outlined"
                        href="https://printology.robotics-media.com"
                        target="_blank"
                        rel="noreferrer"
                        sx={{
                            color: 'white',
                            borderColor: 'white',
                            fontFamily: 'PT Mono, monospace',
                            fontWeight: 'bold',
                            borderRadius: '10px',
                            '&:hover': { borderColor: 'white', opacity: 0.9 },
                        }}
                    >
                        VISIT PRINTOLOGY
                    </Button>
                </Box>
            </Container>
        )
    }
}
export default HomeComponent;
